export default __webpack_public_path__ + "static/media/bigIcon1.b0aa46cd.png";